<template>
  <InputComponent
    v-model="comp"
    :mask="{
      mask: '0000/000/0000/00/00',
      lazy: false,
      placeholderChar: '-',
    }"
    :label="label"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { ValueComp } from '@/utils'
import { InputComponent } from 'vue-elder-input'
import { i18n } from '@/i18n'

const meta = {
  order: 2,
  label: i18n.t('cadastre'),
}

export { meta }
export default {
  props: {
    value: String,
  },
  computed: {
    comp: ValueComp(),
    label: () => meta.label,
  },
  components: {
    InputComponent,
  },
}
</script>
